export function Brand() {
  return (
    <div className="flex items-center gap-3">
      <img
        src="/icons/icon-192.png"
        alt=""
        width="28"
        height="28"
        className="rounded-md"
      />
      <div className="text-(--color-ink)">
        <div className="font-serif font-semibold text-[22px] leading-none tracking-[-0.01em]">
          Glutenless
        </div>
        <div className="mt-[3px] text-[12px] text-(--color-ink-3)">
          Walt Disney World dining, GF-first
        </div>
      </div>
    </div>
  );
}
